class MediaTextSection {
  constructor(el) {
    this.el = el;
    this.playBtn = el.querySelector('[data-play-btn]');
    this.video = el.querySelector('video.section-media-text__video');
    this.poster = el.querySelector('[data-poster]');
    this.videoUrlData = el.querySelector('.section-media-text__video-url-data');

    this.playBtn?.addEventListener('click', () => this.#play());

    if (this.video) {
      this.video.addEventListener('pause', () => this.#showBtn());
      this.video.addEventListener('ended', () => this.#showBtn());
    }
  }

  #play() {
    if (this.video) {
      this.video.play();
    } else if (this.videoUrlData) {
      this.#injectIframe();
    }
    this.#hidePosterAndBtn();
  }

  #injectIframe() {
    const { videoType, videoId } = this.videoUrlData.dataset;
    const iframe = document.createElement('iframe');

    iframe.src =
      videoType === 'youtube'
        ? `https://www.youtube.com/embed/${videoId}?autoplay=1&enablejsapi=1`
        : `https://player.vimeo.com/video/${videoId}?autoplay=1`;

    iframe.className = 'section-media-text__video section-media-text__video--iframe';
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allowfullscreen', '');
    iframe.allow = 'autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media';

    this.videoUrlData.replaceWith(iframe);
    this.videoUrlData = null;
  }

  #hidePosterAndBtn() {
    this.playBtn?.setAttribute('hidden', '');
    this.poster?.setAttribute('hidden', '');
  }

  #showBtn() {
    this.playBtn?.removeAttribute('hidden');
  }
}

document.querySelectorAll('[data-section-media-text]').forEach((el) => new MediaTextSection(el));
